module.exports = __webpack_public_path__ + "img/down-butterfly.8c8c7028.svg";